module.exports = __webpack_public_path__ + "fa-brands-400.1a575a4138e5f366474f.woff";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff
// module chunks = 2